import { useMemo } from 'react';
import { AsyncComponentHookResult } from '../../../../Types/ComponentHookResult';
import { GeneralAssumptionsDTO } from '../../../types/generalAssumptionsDTO';
import { useFinancialPlanQuery } from '../../../api/useFinancialPlanQuery';

export const useGeneralAssumptions = (): AsyncComponentHookResult<GeneralAssumptionsDTO> => {
  const queryResult = useFinancialPlanQuery();

  const data = useMemo(() => {
    if (!queryResult.data) {
      return null;
    }

    return queryResult.data.GeneralAssumptions;
  }, [queryResult.data]);

  return {
    ...queryResult,
    data,
  };
};
